import React, { useEffect } from 'react';
import Card from "react/components/Card";
import InputSwitch from "react/components/InputSwitch";
import { toggleDeferredSubmissions } from "redux/actions/settings";
import { useDispatch, useSelector } from "react-redux";
import TransactionSummaryComponent from "react/components/TransactionSummaryComponent";
import { forceSendOfflineTransactionRequests, updateOfflineTransactionList } from "redux/actions/transactions";
import Button from "react/components/Button";

export default function DevelopmentSettings() {
	const dispatch = useDispatch();
	const deferredSubmissionsActive = useSelector((state) => state.settings.deferredSubmissionsActive);
	const offlineTransactions = useSelector((state) => state.transactions.offlineTransactions);
	const sendingOfflineTransactions =
		useSelector((state) => state.transactions.sendingOfflineTransactions);
	const deferredSubmissionsChanged = (event) => {
		dispatch(toggleDeferredSubmissions(!event.target.checked));
	};


	/**
	 * Request that the offline transaction list get updated
	 */
	useEffect(() => {
		dispatch(updateOfflineTransactionList());
	}, []);


	return (
		<div>
			<div className='row'>
				<div className='col s12'>
					<Card
						cardTitle='Features'
					>
						<InputSwitch
							disabled={true}
							checked={!deferredSubmissionsActive}
							onChange={deferredSubmissionsChanged}
						>
							Deferred Submissions Paused
							(Budget Updates will not be submitted - Not Available)
						</InputSwitch>
					</Card>
				</div>
			</div>
			<div className='row'>
				<div className='col s12'>
					<Card
						cardTitle='Updates that are not submitted'>

						{offlineTransactions.length > 0 &&
						<div className='row'>
							<div className='col s12'>
								<Button
									disabled={sendingOfflineTransactions}
									onClick={() => {
										dispatch(forceSendOfflineTransactionRequests());
									}}
								>
									Force Resending Offline Updates
								</Button>
							</div>
						</div>
						}
						{offlineTransactions.map((offlineTransaction) => {
							return (<TransactionSummaryComponent
								key={offlineTransaction.submit_id}
								categoryEditable={false}
								viewOnly={true}
								transaction={offlineTransaction}
								allowDeletingOfflineTransaction={true}
							/>);
						})}
					</Card>
				</div>
			</div>

			<div className='row'>
				<div className='col s12'>
					<Card
						cardTitle='Tests'>
						<a href={`${siteUrl}/test`}>Tests</a>
					</Card>
				</div>
			</div>
		</div>
	);
}